var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "128px",
    height: "128px",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "favicon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 64,
    cy: 60,
    r: 41
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "favicon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(6.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fav"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9230769,23.0769231 L92.984127,23.1697192 L93.0636429,83.2042528 C93.0709579,88.7270955 88.5997394,93.2101741 83.0768967,93.2174891 C83.0680667,93.2175008 83.0592367,93.2175008 83.0504067,93.2174891 L23.015873,93.1379731 L23.015873,93.1379731 L22.9230769,23.0769231 Z",
    id: "Rectangle",
    fill: "#FFB300",
    transform: "translate(58.000000, 58.153846) rotate(-315.000000) translate(-58.000000, -58.153846) "
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#1E88E5",
    cx: 81.015873,
    cy: 35.0769231,
    rx: 34.984127,
    ry: 35.0769231
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy",
    fill: "#F22E52",
    cx: 34.984127,
    cy: 35.0769231,
    rx: 34.984127,
    ry: 35.0769231
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0011958,8.66054359 C65.3355542,15.0903329 69.968254,24.5411804 69.968254,35.0769231 C69.968254,45.613144 65.3351336,55.0643714 58.0001968,61.4941783 C50.6644458,55.0635133 46.031746,45.6126657 46.031746,35.0769231 C46.031746,24.6158002 50.5990556,15.2242593 57.8433738,8.79761523 Z",
    id: "Combined-Shape",
    fill: "#00C853"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Oval",
    fillOpacity: 0.1,
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavicon);
export default __webpack_public_path__ + "static/media/favicon.999c31606875785a28f492d501f0df2f.svg";
export { ForwardRef as ReactComponent };